import config from '@/common/config';
class ChatSignalrService {

    constructor() {
        this.chatHub = null;
    }

    sendMessage(messageData, callback) {
        // if ($.connection.hub.state !== $.signalR.connectionState.connected) {
        //     if (callback) {
        //         callback();
        //     }
        //     cf.notify.warn(window.L('ChatIsNotConnectedWarning'));
        //     return;
        // }

        // this.chatHub.server
        //     .sendMessage(messageData)
        //     .done(result => {
        //         if (result) {
        //             cf.notify.warn(result);
        //         }
        //     })
        //     .always(() => {
        //         if (callback) {
        //             callback();
        //         }
        //     });
        if (this.chatHub.connection.connectionState !== 1) {
            callback && callback();
            cf.notify.warn(cf.localize('ChatIsNotConnectedWarning'));
            return;
        }

        this.chatHub.invoke('sendMessage', messageData).then(function (result) {
            if (result) {
                cf.notify.warn(result);
            }
            callback && callback();
        });
    }

    init() {
        this.startConnection(config.remoteUrl + '/signalr-chat', this.configureConnection)
            .then(function (connection) {
                cf.log.debug('Connected to SignalR CHAT server!');
                cf.event.trigger('app.chat.connected');

                // Call the Register method on the hub.
                connection.invoke('register').then(function () {
                    cf.log.debug('Registered to the SignalR CHAT server!');
                });
            })
            .catch(function (error) {
                cf.log.debug(error.message);
            });

        // this.chatHub = $.connection.chatHub;

        // if (!this.chatHub) {
        //     return;
        // }

        // $.connection.hub.stateChanged(data => {
        //     if (data.newState === $.connection.connectionState.connected) {
        //         cf.event.trigger('app.chat.connected');
        //     }
        // });

        // this.chatHub.client.getChatMessage = message => {
        //     console.log('getChatMessage');
        //     console.log(message);
        //     cf.event.trigger('app.chat.messageReceived', message);
        // };

        // this.chatHub.client.getAllFriends = friends => {
        //     cf.event.trigger('cf.chat.friendListChanged', friends);
        // };

        // this.chatHub.client.getFriendshipRequest = (
        //     friendData,
        //     isOwnRequest
        // ) => {
        //     cf.event.trigger(
        //         'app.chat.friendshipRequestReceived',
        //         friendData,
        //         isOwnRequest
        //     );
        // };

        // this.chatHub.client.getUserConnectNotification = (
        //     friend,
        //     isConnected
        // ) => {
        //     cf.event.trigger('app.chat.userConnectionStateChanged', {
        //         friend: friend,
        //         isConnected: isConnected
        //     });
        // };

        // this.chatHub.client.getUserStateChange = (friend, state) => {
        //     cf.event.trigger('app.chat.userStateChanged', {
        //         friend: friend,
        //         state: state
        //     });
        // };

        // this.chatHub.client.getallUnreadMessagesOfUserRead = friend => {
        //     cf.event.trigger('app.chat.allUnreadMessagesOfUserRead', {
        //         friend: friend
        //     });
        // };

        // this.chatHub.client.getReadStateChange = friend => {
        //     cf.event.trigger('app.chat.readStateChange', {
        //         friend: friend
        //     });
        // };
    }

    startConnection(url, configureConnection) {
        var $this = this;
        if (cf.signalr.remoteServiceBaseUrl) {
            url = cf.signalr.remoteServiceBaseUrl + url;
        }

        if (cf.signalr.qs) {
            url += '?' + cf.signalr.qs;
        }

        return function start(transport) {
            // cf.log.debug('Starting connection using ' + signalR.HttpTransportType[transport] + ' transport');

            var connection = new signalR.HubConnectionBuilder()
                .withUrl(url, transport)
                .build();

            if (configureConnection && typeof configureConnection === 'function') {
                configureConnection(connection, $this);
            }

            return connection.start()
                .then(function () {
                    return connection;
                })
                .catch(function (error) {
                    cf.log.debug('Cannot start the connection using ' + signalR.HttpTransportType[transport] + ' transport. ' + error.message);
                    cf.log.debug('Cannot start the connection using ' + signalR.HttpTransportType[transport] + ' transport. ' + error.message);
                    if (transport !== signalR.HttpTransportType.LongPolling) {
                        return start(transport + 1);
                    }

                    return Promise.reject(error);
                });
        }(signalR.HttpTransportType.WebSockets);
    }

    configureConnection(connection, $this) {
        // Set the common hub
        cf.signalr.hubs.chat = connection;

        $this.chatHub = connection;

        // Reconnect if hub disconnects
        connection.onclose(function (e) {
            if (e) {
                cf.log.debug('Chat connection closed with error: ' + e);
            }
            else {
                cf.log.debug('Chat disconnected');
            }

            if (!cf.signalr.autoConnect) {
                return;
            }

            setTimeout(function () {
                connection.start();
            }, 5000);
        });

        // Register to get notifications
        $this.registerChatEvents(connection);
    }

    registerChatEvents(connection) {
        connection.on('getChatMessage', function (message) {
            cf.event.trigger('app.chat.messageReceived', message);
        });

        connection.on('getAllFriends', function (friends) {
            cf.event.trigger('abp.chat.friendListChanged', friends);
        });

        connection.on('getFriendshipRequest', function (friendData, isOwnRequest) {
            cf.event.trigger('app.chat.friendshipRequestReceived', friendData, isOwnRequest);
        });

        connection.on('getUserConnectNotification', function (friend, isConnected) {
            cf.event.trigger('app.chat.userConnectionStateChanged',
                {
                    friend: friend,
                    isConnected: isConnected
                });
        });

        connection.on('getUserStateChange', function (friend, state) {
            cf.event.trigger('app.chat.userStateChanged',
                {
                    friend: friend,
                    state: state
                });
        });

        connection.on('getallUnreadMessagesOfUserRead', function (friend) {
            cf.event.trigger('app.chat.allUnreadMessagesOfUserRead',
                {
                    friend: friend
                });
        });

        connection.on('getReadStateChange', function (friend) {
            cf.event.trigger('app.chat.readStateChange',
                {
                    friend: friend
                });
        });
    }
}

export default new ChatSignalrService();
